import { render, staticRenderFns } from "./PatientNoteItem.vue?vue&type=template&id=e4a03c96&scoped=true"
import script from "./PatientNoteItem.vue?vue&type=script&lang=js"
export * from "./PatientNoteItem.vue?vue&type=script&lang=js"
import style0 from "./PatientNoteItem.vue?vue&type=style&index=0&id=e4a03c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a03c96",
  null
  
)

export default component.exports